import React, { memo, useState } from 'react';
import clsx from 'clsx';

import styles from './CategoryIcon.module.css';

export interface CategoryIconProps {
  image?: string;
  icon: string;
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const CategoryIcon: React.FC<CategoryIconProps> = memo(({
  image,
  icon,
  name,
  size = 'sm',
  className,
}) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const [imgError, setImgError] = useState(false);

  const hasImage = Boolean(image) && !imgError;

  return (
    <span className={clsx(styles.container, styles[size], className)}>
      {hasImage ? (
        <img
          src={image}
          alt={name}
          className={clsx(styles.image, imgLoaded && styles.imageLoaded)}
          onLoad={() => setImgLoaded(true)}
          onError={() => setImgError(true)}
          loading="lazy"
        />
      ) : (
        <span className={styles.emoji} role="img" aria-label={name}>
          {icon}
        </span>
      )}
    </span>
  );
});

CategoryIcon.displayName = 'CategoryIcon';

export default CategoryIcon;
